import { type Bonus, BonusStage } from '@/api/common';

export type IssuableItem = Pick<Bonus, 'id' | 'stage' | 'createdAt'> &
  Partial<
    Pick<Bonus, 'amountCents' | 'amountWagerRequirementCents' | 'currency'>
  > & { activatable?: boolean };

export const UNSEEN_BONUS_STAGES: readonly BonusStage[] = [
  BonusStage.Issued,
  BonusStage.HandleBets,
];

const isUnseenStage = (stage?: BonusStage): boolean =>
  stage != null && UNSEEN_BONUS_STAGES.includes(stage);

const issuedAtMs = (item: IssuableItem): number =>
  new Date(item.createdAt).getTime();

export const isUnseenBonus = (
  item: IssuableItem,
  lastSeenAt: number | null
): boolean => isUnseenStage(item.stage) && issuedAtMs(item) > (lastSeenAt ?? 0);

export const hasUnseenBonus = (
  items: IssuableItem[] | undefined | null,
  lastSeenAt: number | null
): boolean => !!items?.some((item) => isUnseenBonus(item, lastSeenAt));

const CREDITED_BONUS_STAGES: readonly BonusStage[] = [
  BonusStage.Issued,
  BonusStage.HandleBets,
  BonusStage.Activated,
  BonusStage.WagerDone,
  BonusStage.Finished,
];

export const isWagerFreeCash = (item: IssuableItem): boolean =>
  !item.activatable &&
  item.amountCents != null &&
  item.currency != null &&
  item.amountWagerRequirementCents === 0 &&
  item.stage != null &&
  CREDITED_BONUS_STAGES.includes(item.stage);

export const isNewlyWagerFreeCash = (
  incoming: IssuableItem,
  previous?: IssuableItem
): boolean => isWagerFreeCash(incoming) && !previous;

export const isNewlyIssuedBonus = (
  incoming: IssuableItem,
  previous?: IssuableItem
): boolean => isUnseenStage(incoming.stage) && !isUnseenStage(previous?.stage);
